export enum InfoActionTypes {
  GET_INFOS_PENDING = '@@info/GET_INFOS_PENDING',
  GET_INFOS_SUCCESS = '@@info/GET_INFOS_SUCCESS',
  GET_INFOS_ERROR = '@@info/GET_INFOS_ERROR',
}
